import { ActionButton, OfficeHeader, TableComponent } from "components";

import clsx from "clsx";
import { extractVehicleNumberFromDetails } from "utils";
import numeral from "numeral";
import { useAppLocation } from "_graphql/cache/auth";
import { useKEKBankingTrayOffers } from "hooks/data/use-offers";

type Props = {};

const BankingTrayOffersPage = (props: Props) => {
  const { params } = useAppLocation();
  const { offers, loading, refetch } = useKEKBankingTrayOffers({
    offerIds: params?.id ? params.id.split("-").map((id) => id) : [],
  });
  return (
    <main className="flex-1 flex flex-col overflow-hidden bg-background-500">
      <OfficeHeader />
      <div className="flex flex-1 overflow-y-auto">
        <div className="flex-1 mx-auto min-w-0  py-4 sm:py-6 overflow-hidden overflow-y-auto light flex">
          <TableComponent
            title={"Banking Tray"}
            columns={[
              {
                name: "Policy #",
                accessor: "offer_detail.policy_number",
                render: (value) => (
                  <div className="flex flex-col items-start flex-wrap break-all break-words">
                    <div className="flex flex-row items-center gap-x-1">
                      <span className="font-bold text-xs overflow-hidden text-ellipsis  ">
                        {value.offer_detail?.policy_number || "N/A"}
                      </span>
                    </div>
                    <div
                      className={clsx(
                        "p-0.5 rounded-full",
                        {
                          " text-green-600": value.offer_from === "INTERNAL",
                          " text-yellow-600": value.offer_from !== "INTERNAL",
                        },
                        "text-xs font-medium"
                      )}
                    >
                      <span>{value.offer_from}</span>
                    </div>
                  </div>
                ),
              },
              {
                name: "Reinsured",
                accessor: "insurer.insurer_company_name",
                render: (value) => (
                  <div className="flex flex-col text-xs">
                    <span className="font-medium">
                      {value.insurer?.insurer_company_name || "N/A"}
                    </span>
                    <span className="font-light">
                      {value.insurer?.insurer_company_email || "N/A"}
                    </span>
                  </div>
                ),
              },
              {
                name: "Insured",
                accessor: "offer_detail.insured_by",
                render: (value) => {
                  const details = JSON.parse(
                    value?.offer_detail?.offer_details || "[]"
                  );
                  return (
                    <div className="flex flex-col text-xs ">
                      <span className="font-medium">
                        {value.offer_detail?.insured_by || "N/A"}
                      </span>
                      <span className="font-light">
                        {[
                          "Motor Comprehensive Fleet",
                          "Motor Comprehensive",
                          "Motor Comprehensive (Automobile Fac Facility)",
                        ].includes(value?.classofbusiness?.business_name || "")
                          ? extractVehicleNumberFromDetails(details)
                          : ""}
                      </span>
                    </div>
                  );
                },
              },
              {
                name: "Class Of Business",
                accessor: "classofbusiness.business_name",
                render: (value) => (
                  <div className="flex flex-col text-xs">
                    <span className="font-medium">
                      {value.classofbusiness?.business_name || "N/A"}
                    </span>
                  </div>
                ),
              },
              {
                name: "Sum Insured",
                accessor: "sum_insured",
                render: (value) => (
                  <div className="flex flex-col text-xs">
                    <span className="font-medium">
                      {value?.offer_detail?.currency}{" "}
                      {numeral(value.sum_insured).format("0,0 ") || "N/A"}
                    </span>
                  </div>
                ),
              },
              {
                name: "Rate (%)",
                accessor: "rate",
              },
              {
                name: "Premium",
                accessor: "premium",
                render: (value) => (
                  <div className="flex flex-col text-xs">
                    <span className="font-medium">
                      {value?.offer_detail?.currency}{" "}
                      {numeral(value.premium).format("0,0 ") || "N/A"}
                    </span>
                  </div>
                ),
              },
              {
                name: "Offer Date",
                accessor: "created_at",
                render: (value) =>
                  new Date(value.created_at).toLocaleDateString(),
              },
              {
                name: "Status",
                accessor: "offer_status",
                render: (value) => (
                  <div className="flex flex-col items-start">
                    <div
                      className={clsx(
                        "p-1 rounded-lg",
                        {
                          "bg-blue-600/30 text-blue-600":
                            value.offer_status === "OPEN",
                          "bg-green-50/30 text-green-600":
                            value.offer_status === "CLOSED",
                          "bg-yellow-50/30 text-yellow-600":
                            value.offer_status === "PENDING",
                        },
                        "text-xs font-medium"
                      )}
                    >
                      <span>{value.offer_status}</span>
                    </div>
                  </div>
                ),
              },
              {
                name: "Approval Status",
                accessor: "approval_status",
                render: (value) => (
                  <div className="flex">
                    <div
                      className={clsx(
                        "p-1 rounded-lg",
                        {
                          "bg-green-600/30 text-green-600":
                            value.approval_status === "APPROVED",
                          "bg-yellow-300/30 text-yellow-600":
                            value.approval_status === "UNAPPROVED",
                        },
                        "text-xs font-medium"
                      )}
                    >
                      <span>{value.approval_status}</span>
                    </div>
                  </div>
                ),
              },
              {
                name: "Created By",
                accessor: "employee.employee_first_name",
                render: (value) => (
                  <div className="flex flex-row leading-0">
                    <span>
                      {value?.employee?.employee_first_name}{" "}
                      {value?.employee?.employee_last_name}
                    </span>
                  </div>
                ),
              },

              {
                name: "Actions",
                accessor: "actions",
                render: (value) => (
                  <>
                    <ActionButton
                      action="expand"
                      tooltip="Record & View Payments"
                      onClick={() => {}}
                    />
                  </>
                ),
              },
            ]}
            loading={loading}
            data={offers}
            refetch={refetch}
          />
        </div>
      </div>
    </main>
  );
};

export default BankingTrayOffersPage;
